module.exports = __webpack_public_path__ + "static/media/sidebar-4.4bf554d9.jpg";